import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { base_url } from "../../services/configServices/config";

const SiteTitle = ({ title }) => {
  const setting = useSelector((state) => state.meta?.setting);

  return (
    <Helmet>
      <title>
        {title} | {setting?.title ?? "کافه روزانه"}
      </title>
      <link rel="icon" type="image/png" href={base_url + setting?.logo} />
    </Helmet>
  );
};

export default SiteTitle;
